<template>
    <div class="ag-cell-edit-wrapper">
        <div
            role="presentation"
            class="ag-cell-editor ag-labeled ag-label-align-left"
        >
            <div class="ag-wrapper">

                <span>{{ this.params.placeholder }}</span>
                <b-form-checkbox-group
                    class="ag-input-field-form-checkbox-group"
                    v-model="value"
                    :options="options"
                    stacked
                    :multiple="true"
                ></b-form-checkbox-group>
                
            </div>
        </div>
    </div>
</template>

<script>
    import isFunction from 'lodash/isFunction';

    export default {
        data() {
            return {
                loading: false,
                value: [],
                options: [],
            }
        },
        components: {

        },        
        created() {
            if (isFunction(this.params.options)) {
                this.loading = true;
                Promise.resolve(this.params.options())
                    .then(options => {
                        this.value = this.params.values;
                        this.placeholder = this.params.placeholder || '';
                        this.options = options;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.value = this.params.values;
                this.placeholder = this.params.placeholder || '';
                this.options = this.params.options;
            }
        },
        methods: {
            getValue() {
                return this.value;
            },
			isPopup() {
				return true;	
			},		            
        }
    }
</script>

<style lang="scss" scoped>
    :deep(.ag-input-field-form-checkbox-group) {
        color: #404040 !important;
        text-decoration: none !important;
        border: none;
        width: 100%;
        height: 100%;
        background-color: white;
        padding: 10px;
        border-radius: 5px;        
    }
</style>
